import { CHUNK_WIDTH, CHUNK_DEPTH, CHUNK_HEIGHT, CHUNK_SIZE, blockIndex } from '@shared/chunk-constants';
import { BlockId } from '@shared/block-ids';

export class Chunk {
  readonly cx: number;
  readonly cz: number;
  readonly blocks: Uint8Array;
  dirty = true;
  generated = false;

  constructor(cx: number, cz: number, blocks?: Uint8Array) {
    this.cx = cx;
    this.cz = cz;
    this.blocks = blocks ?? new Uint8Array(CHUNK_SIZE);
  }

  getBlock(x: number, y: number, z: number): BlockId {
    if (x < 0 || x >= CHUNK_WIDTH || z < 0 || z >= CHUNK_DEPTH || y < 0 || y >= CHUNK_HEIGHT) {
      return BlockId.AIR;
    }
    return this.blocks[blockIndex(x, y, z)] as BlockId;
  }

  setBlock(x: number, y: number, z: number, id: BlockId): void {
    if (x < 0 || x >= CHUNK_WIDTH || z < 0 || z >= CHUNK_DEPTH || y < 0 || y >= CHUNK_HEIGHT) {
      return;
    }
    this.blocks[blockIndex(x, y, z)] = id;
    this.dirty = true;
  }

  getHighestBlock(x: number, z: number): number {
    for (let y = CHUNK_HEIGHT - 1; y >= 0; y--) {
      if (this.blocks[blockIndex(x, y, z)] !== BlockId.AIR) {
        return y;
      }
    }
    return 0;
  }

  isEmpty(): boolean {
    for (let i = 0; i < CHUNK_SIZE; i++) {
      if (this.blocks[i] !== BlockId.AIR) return false;
    }
    return true;
  }
}
